export default __webpack_public_path__ + "static/media/Logo_Small_Transparent.938aee68.webp";